// Marketing Posts admin API — біріктірілген оркестратор.
// Бір POST → Story (мобиль) + Banner (сайт) + (опционалды) чат-броуадкаст.
// Бэкенд: src/app/api/admin/marketing_posts.py + services/marketing_broadcast.py

import { API_URL } from "../config/connect";

const getAuthHeaders = () => {
  const token = localStorage.getItem("google_id_token");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

async function request(path, options = {}, fallbackMessage = "Запрос не выполнен") {
  const response = await fetch(`${API_URL}${path}`, {
    headers: getAuthHeaders(),
    ...options,
  });
  if (!response.ok) {
    let message = fallbackMessage;
    try {
      const data = await response.json();
      message = data?.detail?.message || data?.detail || data?.message || fallbackMessage;
    } catch {}
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  // DELETE-те 204 болуы мүмкін — JSON жоқ
  if (response.status === 204) return null;
  return response.json();
}

/* -------------------------------------------------------------- */
/* CRUD                                                            */
/* -------------------------------------------------------------- */

/**
 * GET /api/v1/admin/marketing-posts
 * @param {Object} params - { page, limit, type, is_active }
 */
export const listMarketingPosts = async (params = {}) => {
  const qs = new URLSearchParams();
  if (params.page) qs.append("page", params.page);
  if (params.limit) qs.append("limit", params.limit);
  if (params.type) qs.append("type", params.type);
  if (params.is_active !== undefined) qs.append("is_active", params.is_active);
  const suffix = qs.toString() ? `?${qs}` : "";
  return request(`/api/v1/admin/marketing-posts${suffix}`, { method: "GET" },
    "Не удалось загрузить посты");
};

/** GET /api/v1/admin/marketing-posts/{id} */
export const getMarketingPost = (id) =>
  request(`/api/v1/admin/marketing-posts/${id}`, { method: "GET" },
    "Не удалось загрузить пост");

/**
 * POST /api/v1/admin/marketing-posts
 * @param {Object} body - { type, title, body, image_url, video_url, cta_link,
 *                          display_modes, broadcast_to_chat, banner_active,
 *                          audience_user_types, audience_region_ids, ...
 *                          publish_at, expires_at }
 */
export const createMarketingPost = (body) =>
  request(`/api/v1/admin/marketing-posts`, {
    method: "POST",
    body: JSON.stringify(body),
  }, "Не удалось создать пост");

/** PATCH /api/v1/admin/marketing-posts/{id} */
export const updateMarketingPost = (id, body) =>
  request(`/api/v1/admin/marketing-posts/${id}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  }, "Не удалось обновить пост");

/** DELETE /api/v1/admin/marketing-posts/{id} — soft delete */
export const deleteMarketingPost = (id) =>
  request(`/api/v1/admin/marketing-posts/${id}`, { method: "DELETE" },
    "Не удалось удалить пост");

/* -------------------------------------------------------------- */
/* Broadcast + audience                                            */
/* -------------------------------------------------------------- */

/** POST /api/v1/admin/marketing-posts/{id}/rebroadcast — явная пере-рассылка */
export const rebroadcastMarketingPost = (id) =>
  request(`/api/v1/admin/marketing-posts/${id}/rebroadcast`, { method: "POST" },
    "Не удалось переотправить рассылку");

/**
 * POST /api/v1/admin/marketing-posts/preview-audience
 * @param {Object} body - audience filters; { estimated_recipients_count } қайтарады
 */
export const previewAudience = (body) =>
  request(`/api/v1/admin/marketing-posts/preview-audience`, {
    method: "POST",
    body: JSON.stringify(body),
  }, "Не удалось рассчитать аудиторию");

/** GET /api/v1/admin/marketing-posts/audience-options */
export const getAudienceOptions = () =>
  request(`/api/v1/admin/marketing-posts/audience-options`, { method: "GET" },
    "Не удалось получить опции аудитории");

/* -------------------------------------------------------------- */
/* Analytics                                                       */
/* -------------------------------------------------------------- */

/** GET /api/v1/admin/marketing-posts/{id}/analytics?days=30 */
export const getMarketingPostAnalytics = (id, days = 30) =>
  request(`/api/v1/admin/marketing-posts/${id}/analytics?days=${days}`, { method: "GET" },
    "Не удалось загрузить аналитику");
